export const distributedCounterProducerServerlessYml = `provider:
  name: aws
  runtime: python3.9
  region: eu-central-1

functions:
  report_like:
    handler: src.producer.count_video_like
    reservedConcurrency: 1000
    memorySize: 128
    timeout: 30
    events:
      - http:
          path: /videos/{video_id}/likes
          method: post
          private: false
`;

export const distributedCounterProducerLambda = `from kafka.producer import KafkaProducer


def count_video_like(event, context):
    video_identifier = event['pathParameters']['video_id']
    producer.send(topic='video_clicks_ingestion', value=video_identifier)

    return {
        "statusCode": 200,
        "headers": {
            "Content-Type": "application/json"
        },
        "body": json.dumps({
            'id': video_identifier
        })
    }
`;

export const distributedCounterDockerComposeForKafka = `version: '3.7'

services:
  zookeeper:
    image: confluentinc/cp-zookeeper:7.0.1
    container_name: zookeeper
    environment:
      ZOOKEEPER_CLIENT_PORT: 2181
      ZOOKEEPER_TICK_TIME: 2000
    networks:
      main-net:
        ipv4_address: 172.30.1.0
        aliases:
          - "zookeper.local"
    restart: on-failure
    user: root
    volumes:
      - ./zoo/data:/var/lib/zookeeper/data
      - ./zoo/log:/var/lib/zookeeper/log

  kafka-broker-1:
    image: confluentinc/cp-kafka:7.0.1
    container_name: kafka-broker-1
    depends_on:
      - zookeeper
    environment:
      KAFKA_BROKER_ID: 2
      KAFKA_ZOOKEEPER_CONNECT: zookeper.local:2181
      KAFKA_LISTENERS: INTERNAL://0.0.0.0:9092,OUTSIDE://0.0.0.0:9094
      KAFKA_ADVERTISED_LISTENERS: INTERNAL://kafka.broker.1.local:9092,OUTSIDE://localhost:9094
      KAFKA_LISTENER_SECURITY_PROTOCOL_MAP: INTERNAL:PLAINTEXT,OUTSIDE:PLAINTEXT
      KAFKA_INTER_BROKER_LISTENER_NAME: INTERNAL
      KAFKA_OFFSETS_TOPIC_REPLICATION_FACTOR: 1
      KAFKA_TRANSACTION_STATE_LOG_MIN_ISR: 1
      KAFKA_TRANSACTION_STATE_LOG_REPLICATION_FACTOR: 1
      KAFKA_LOG_DIRS: /kafka/logs
      KAFKA_LOG_RETENTION_HOURS: 1
      KAFKA_NUM_PARTITIONS: 3
    user: root
    ports:
      - "9094:9094"
    volumes:
      - ./kafka_files-1:/kafka/logs
    networks:
      main-net:
        ipv4_address: 172.30.1.2
        aliases:
          - "kafka.broker.1.local"


networks:
  main-net:
    external: true
`;

export const distributedCounterDockerComposeForFaust = `version: '3.7'

services:
  faust.worker.1:
    build:
      context: ..
      dockerfile: ./docker/Dockerfile
    container_name: faust.worker.1
    networks:
      main-net:
        ipv4_address: 172.30.1.10
        aliases:
          - "faust.worker.1"
    environment:
      dataDir: /workers/worker1
    entrypoint:
      - "/workers/config/entrypoint.sh"
    volumes:
      - ../:/workers
    restart: on-failure

  faust.worker.2:
    build:
      context: ..
      dockerfile: ./docker/Dockerfile
    container_name: faust.worker.2
    networks:
      main-net:
        ipv4_address: 172.30.1.11
        aliases:
          - "faust.worker.2"
    environment:
      dataDir: /workers/worker2
    entrypoint:
      - "/workers/config/entrypoint.sh"
    volumes:
      - ../:/workers
    restart: on-failure

networks:
  main-net:
    external: true`;

export const distributedCounterDockerfileForWorkers = `FROM yamitzky/docker-python-rocksdb:latest

RUN mkdir -p /workers
ENV PYTHONPATH "$PYTHONPATH:/workers"
ENV PATH="\${PATH}:/root/.poetry/bin"
WORKDIR /workers

RUN pip install --upgrade pip && pip install poetry
COPY pyproject.toml poetry.lock /workers/
RUN poetry config virtualenvs.create false \\
  && poetry install --no-dev --no-interaction --no-ansi --no-root
RUN rm /workers/pyproject.toml /workers/poetry.lock`;

export const distributedCounterFaustApp = `from src.models import VideoClick, VideoAggregation
import faust
from src.utils.config_utils import ConfigUtils

config = ConfigUtils.get_config()

app = faust.App(
    config.kafka_group_id,
    broker=config.kafka_broker_url,
    store='rocksdb://',
    replication_factor=1
)`;

export const processVideoIdentifiersAgent = `video_clicks_ingestion_topic = app.topic(
    'video_clicks',
    value_serializer='raw',
    retention=900,  # Number of seconds to keep messages in the topic before they can be expired.
    partitions=3
)

video_clicks_grouped_by_identifier = app.topic(
    'group_by',
    value_serializer='raw',
    retention=900,
    partitions=3
)

def _get_key_from_raw_video_data(raw_data):
    return VideoClick.from_raw_data(raw_data).identifier


@app.agent(video_clicks_ingestion_topic)
async def process_video_identifiers(stream: faust.Stream):
    async for raw_data in stream.group_by(
            key=_get_key_from_raw_video_data,
            topic=video_clicks_grouped_by_identifier,
            name='dummy_suffix'):
        yield raw_data`;

export const videoClickModel = `import faust
from abc import ABC


class VideoClick(faust.Record, ABC):
    identifier: str

    @staticmethod
    def from_raw_data(raw_data: bytes) -> 'VideoClick':
        return VideoClick(raw_data.decode("utf-8"))


class VideoAggregation(faust.Record, ABC):
    type: str
    video_uid: str
    count: int`;

export const distributedCounterAggregationAgent = `one_minute_aggregation_topic = app.topic(
    'count_aggregations_1_min',
    value_type=VideoAggregation,
    retention=900,
    partitions=5
)

async def process_one_minute_window(metadata, value) -> None:
    key, window = metadata
    await one_minute_aggregation_topic.send(
        value=VideoAggregation(
            type='1min',
            video_uid=key,
            count=value
        ))
        
video_counts_1_min = (
    app.Table(
        'in-memory-aggregation-table-1-min',
        default=int,
        partitions=3,
        on_window_close=process_one_minute_window)
    .tumbling(timedelta(minutes=1), expires=timedelta(minutes=1), key_index=True)
    .relative_to_stream())
app.tables.add(video_counts_1_min.key_index_table)

@app.agent(video_clicks_grouped_by_identifier)
async def count_video_identifiers(stream: faust.Stream):
    async for raw_data in stream:
        video = VideoClick.from_raw_data(raw_data)
        video_counts_1_min[video.identifier] += 1`;

export const socketIoServerBasics = `import socketio
from src.utils.config_utils import ConfigUtils
from src.utils.log_service import LogService

config = ConfigUtils.get_config()
logger = LogService.get_logger(config.log_level)
sio = socketio.AsyncServer(async_mode='asgi', ping_timeout=60, cors_allowed_origins='*')
app = socketio.ASGIApp(sio)

@sio.event
async def connect(sid: str, environ: dict):
    logger.info(f'{sid} connected')


@sio.event
def connect_error(e):
    logger.info(f'Server connect failed: {e}')


@sio.event
async def disconnect(sid):
    logger.info(f'Disconnected {sid}')


@sio.event
async def register_room(sid: str, data):
    for room_id in data['rooms']:
        sio.enter_room(sid, room_id)


@sio.event
async def consume_1_min_aggregations(sid: str, data):
    # logic for video-like consumption goes here

`;

export const socketIoServerConsumption = `import json
from aiokafka import AIOKafkaConsumer
import asyncio


one_min_aggregations_consumer = AIOKafkaConsumer(
    'count_aggregations_1_min',
    bootstrap_servers='kafka.broker.1.local:9092',
    auto_offset_reset='earliest',  # If committed offset not found, start from beginning
    enable_auto_commit=True,
    group_id='some-group-id',
    value_deserializer=lambda x: json.loads(x.decode()))


loop = asyncio.get_running_loop()
loop.create_task(one_min_aggregations_consumer.start())


@sio.event
async def consume_1_min_aggregations(sid: str, data):
    async for record in one_min_aggregations_consumer:
        await sio.emit(
            'one_minute_aggregations_event_name',
            {
                'id': record.value['video_uid'],
                'count': record.value['count']
            },
            to=record.value['video_uid']
        )`;

export const distributedCounterSocketService = `import io from 'socket.io-client';

const SOCKET_URL = 'http://172.30.1.11:8000'
const socket = io(SOCKET_URL, {
        timeout: 5000,
        withCredentials: false,
        transports: ['websocket']
    }
);

class SocketService {
    add_error_handler_listener() {
        socket.on("connect_error", (e) => {
            console.error(e);
            socket.close();
        });
    }

    add_connection_handler(callback) {
        socket.on('connect', (socket) => {
            console.log('connected');
        });
    }

    add_handler(event_name, callback) {
        socket.on(event_name, (payload) => {
            callback(payload);
        });
    }

    send_event(event_name, data) {
        socket.emit(event_name, data);
    }

    remove_listeners() {
        socket.close();
    }

    register_to_rooms(roomIdentifiers) {
        socket.emit('register_room', {
            'rooms': roomIdentifiers
        });
    }

    emit(topicName, data) {
        socket.emit(topicName, data);
    }

}

export default new SocketService();`;

export const distributedCounterSocketIoInReactComp = `useEffect(() => {
        SocketService.add_error_handler_listener();
        SocketService.add_connection_handler();
        SocketService.add_handler("one_minute_aggregations_event_name", (payload) => {
            setAggregationsPerMinute(prevLiveCountAggregations => (
                {...prevLiveCountAggregations, [payload.id]: payload.count})
            );
        });

        SocketService.emit('consume_1_min_aggregations', {});

        return () => {
            SocketService.remove_listeners();
        }
    }, []);
    
    useEffect(() => {
        let videoIdentifiers = props.videoMetadata.slice(0, props.numOfVideos).map(function (video) {
            return (video.unique_identifier);
        });
        SocketService.register_to_rooms(videoIdentifiers);
    }, [props.videoMetadata, props.numOfVideos]);`;

export const distributedCounterLocalSetup = `docker network create -d bridge --attachable main-net --subnet 172.30.0.0/16 --gateway 172.30.0.255
mkdir Projects && cd Projects
git clone git@github.com:chrisbek/distributed-counter.git
git clone git@github.com:chrisbek/kafka_consumer_websockets.git
git clone git@github.com:chrisbek/distributed-counter-frontend.git

cd distributed-counter
cp ./config/.env.dev ./config/.env -v
make start-kafka
make start-faust
yarn install
poetry shell
poetry install
cp serverless.dev.yml serverless.yml -v
serverless offline start --stage=dev

cd distributed-counter-frontend
yarn install
yarn run dev

cd kafka_consumer_websockets
cp ./config/.env.dev ./config/.env -v
make start-consumer`;

export const authorizationLocalSetup = `https://github.com/chrisbek/local-stack.git
https://github.com/chrisbek/identity-provider.git
https://github.com/chrisbek/oauth-frontend.git
https://github.com/chrisbek/oauth-backend.git
https://github.com/chrisbek/authorization-service.git
https://github.com/chrisbek/authorization-server-popup.git`;

export const authorizationEtcHosts = `172.30.0.8\tdynamodb.local
172.30.0.5\tidentity-provider.local
172.30.1.0\tauthentication.local authorization-server.local`;

export const authorizationLocalSetupDbAndProxy = `cd local-stack
docker build -t serverless_base:0.0.2 -f ./serverless.Dockerfile  .
make start-databases
make start-nginx`;

export const authorizationLocalSetupIdentityProvider = `cd identity-provider
./start.sh
docker exec -it identity-provider bash
migrations preview
migrations migrate`;

export const authorizationLocalSetupAuthPopup = `cd authorization-server-popup
docker-compose -p auth-popup up -d`;

export const authorizationLocalSetupAuthServer = `cd authorization-server
docker-compose -p authorization_server -f local-stack/docker-compose.yaml up -d
docker exec -it authorization-server bash
scripts/migrations.sh migrations migrate`;


export const authorizationLocalSetupAuthServerUserCreation = `curl --location --request POST 'http://authorization-server.local/api/user' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "email": "bekos.christopher@gmail.com",
    "password": "123456",
    "first_name": "Christopher"
}'`;

export const authorizationLocalSetupFrontend = `cd oauth-frontend
docker-compose -p frontend up -d`;

export const authorizationLocalSetupBackend = `cd oauth-backend
cd local-stack
./stack-run.sh dev`;

